import { render, staticRenderFns } from "./MonthlyEISAlliance.vue?vue&type=template&id=b1622472"
import script from "./MonthlyEISAlliance.vue?vue&type=script&lang=js"
export * from "./MonthlyEISAlliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports